import { render } from "./TableLiteTs.vue?vue&type=template&id=ed923b2e&scoped=true&ts=true"
import script from "./TableLiteTs.vue?vue&type=script&lang=ts"
export * from "./TableLiteTs.vue?vue&type=script&lang=ts"

import "./TableLiteTs.vue?vue&type=style&index=0&id=ed923b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed923b2e"]])

export default __exports__